import { UpdateBasicInfoContinuedInput, UpdateBasicInfoContinuedResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { CustomerLookupMachineContext } from '../../state-machine/types/customerLookupMachine.types';
import { BasicInfoContinuedModel } from '../../state-machine/types/ecommMachine.types';
import { LongFormMachineContext } from '../../state-machine/types/longFormMachine.types';

const updateBasicInfoContinued = async (context: CustomerLookupMachineContext | LongFormMachineContext): Promise<UpdateBasicInfoContinuedResponse> => {
  const basicInfoContinued: BasicInfoContinuedModel = context.basicInfoContinued!;
  const input: UpdateBasicInfoContinuedInput = {
    applicationId: context.application?.lease?.id!,
    customerId: context.application?.customer?.id!,
    birthDate: basicInfoContinued?.birthDate,
    taxpayerIdentificationNumber: basicInfoContinued?.taxpayerIdentificationNumber,
    monthlyIncome: basicInfoContinued?.monthlyIncome!,
  };

  try {
    const response = await applicationFormService.updateBasicInfoContinued(input);
    return response?.data?.updateBasicInfoContinued as UpdateBasicInfoContinuedResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        const forbiddenErrMsg = createForbiddenErrorMessage(err);
        error.forbiddenError = forbiddenErrMsg;
        break;
      case 401:
        const unauthErrMsg = createUnauthorizedErrorMessage(err);
        error.unauthorizedError = unauthErrMsg;
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default updateBasicInfoContinued;
